import * as jsonpatch from 'fast-json-patch';

function getElementsDiff(oldStateElementsById, newStateElementsById) {
  // This function takes project data as input (not planning data)
  const beforeVersion = { elements: oldStateElementsById };
  const currentVersion = { elements: newStateElementsById };

  [beforeVersion, currentVersion].forEach((version) => {
    Object.keys(version.elements).forEach((id) => {
      if (version.elements[id].type == 'task') version.elements[id] = { ...version.elements[id], width: undefined };
    });
  });

  return jsonpatch.compare(beforeVersion, currentVersion);
}

function getProjectDiff(beforeVersion, currentVersion) {
  // This function takes project data as input (not planning data)
  // Warning: if you use toProject, null values are removed by getAll
  const beforeVersionLanesIds = beforeVersion.content.lanes.map(item => item.id);
  const currentVersionLanesIds = currentVersion.content.lanes.map(item => item.id);
  const beforeVersionProcessStepsIds = beforeVersion.content.process.steps.map(item => item.id);
  const currentVersionProcessStepsIds = currentVersion.content.process.steps.map(item => item.id);

  const beforeVersionContentById = { ...beforeVersion.content }; // no mutation to input objects
  const currentVersionContentById = { ...currentVersion.content }; // no mutation to input objects
  [beforeVersionContentById, currentVersionContentById].forEach((content) => {
    if (content.elements) {
      const elementsById = {};
      for (let i = 0, n = content.elements.length; i < n; i++) {
        let item = content.elements[i];
        if (item.type == 'task') item = _.omit(item, 'width');
        elementsById[`id=${item.id}`] = item;
      }
      content.elements = elementsById;
    }
    if (content.lanes) {
      const lanesById = {};
      for (let i = 0, n = content.lanes.length; i < n; i++) {
        const item = content.lanes[i];
        lanesById[`id=${item.id}`] = item;
      }
      content.lanes = lanesById;
    }
    if (content.process?.steps) {
      const processStepsById = {};
      for (let i = 0, n = content.process.steps.length; i < n; i++) {
        const item = content.process.steps[i];
        processStepsById[`id=${item.id}`] = item;
      }
      content.process = { ...content.process, steps: processStepsById };
    }
  });

  const patch = jsonpatch.compare(beforeVersionContentById, currentVersionContentById);
  if (! angular.equals(beforeVersionLanesIds, currentVersionLanesIds)) patch.push({ op: "order", path: "/lanes", value: currentVersionLanesIds });
  if (! angular.equals(beforeVersionProcessStepsIds, currentVersionProcessStepsIds)) patch.push({ op: "order", path: "/process/steps", value: currentVersionProcessStepsIds });
  return patch;
}

export default {
  getElementsDiff,
  getProjectDiff,
};
